export default "__VITE_PUBLIC_ASSET__57801d13__"